import type { IconDef } from '../types';

export const lock: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M12.5 0C15.81 0 18.5 2.69 18.5 6V10H19C20.65 10 22 11.35 22 13V21C22 22.65 20.65 24 19 24H6C4.35 24 3 22.65 3 21V13C3 11.35 4.35 10 6 10H6.5V6C6.5 2.69 9.19 0 12.5 0ZM6.21973 11.7197C5.66995 11.6999 5.19984 12.1299 5.17969 12.6797L4.83008 20.6699C4.81008 21.2199 5.24004 21.69 5.79004 21.71L18.7803 22.2803C19.3301 22.3001 19.8002 21.8701 19.8203 21.3203L20.1699 13.3301C20.1899 12.7801 19.76 12.31 19.21 12.29L6.21973 11.7197ZM11.1455 16.3604C11.5055 15.3705 12.4256 14.7906 13.1855 15.0703C13.9455 15.3403 14.2759 16.3704 13.916 17.3604C13.546 18.3503 12.636 18.9303 11.876 18.6504C11.116 18.3804 10.7855 17.3503 11.1455 16.3604ZM12.5 2C10.29 2 8.5 3.79 8.5 6V10H16.5V6C16.5 3.79 14.71 2 12.5 2Z',
    },
  ],
};
